import { Button, Grid, Typography } from "@mui/material";
import { ModalComponent } from "../../modal";
import { useRef, useState } from "react";
import Thumb from "../../../assets/img/logo with description.svg"
import ThumbPartner from "../../../assets/img/thum partner.jpeg"


interface Props {
    open: boolean;
    onClose: () => void;
}

export const ModalVideo = ({
    onClose,
    open,
}: Props) => {
    const [loading, setLoading] = useState(false)
    const videoRef = useRef<HTMLVideoElement | null>(null);

    const handlePlay = () => {
        const video = videoRef.current;

        if (video) {
            if (video.requestFullscreen) {
                video.requestFullscreen();
            } else if ((video as any).webkitEnterFullscreen) {
                (video as any).webkitEnterFullscreen();
            } else if ((video as any).msRequestFullscreen) {
                (video as any).msRequestFullscreen();
            }
        }
    };

    return (
        <ModalComponent open={open} withoutHeader>
            <Grid
                width={"100%"}
                display={"flex"}
                flexDirection={"column"}
                gap={"1rem"}
            >
                <Typography fontSize={"1.8rem"} textAlign={"center"} fontWeight={700}>
                    PARA CONTINUAR <br />BAIXE AGORA O ATALHO GYROO
                </Typography>

                <Typography fontSize={"1.6rem"} textAlign={"center"} fontWeight={500} mb={"-1rem"} mt={"1rem"} sx={{ opacity: .5 }}>
                    Assista o vídeo passo a passo abaixo e aprenda a baixar o atalho <strong>GYROO</strong>
                </Typography>
            </Grid>

            <Grid
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                mt={"2.5rem"}
            >
                <video ref={videoRef} controls controlsList="nodownload" preload="auto" poster={Thumb} onPlay={handlePlay} style={{
                    maxWidth: '100%',
                    borderRadius: "20px"
                }}>
                    <source src={"https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/SMARTPHONE+ATALHO+.mp4"} type="video/mp4" />
                </video>

            </Grid>

            <Grid
                width={"100%"}
                display={"flex"}
                flexWrap={"wrap-reverse"}
                justifyContent={"flex-end"}
                flexDirection={"row"}
                gap={"1rem"}
                mt={"2.5rem"}
            >
                <Button
                    variant="outlined"
                    sx={{
                        height: "4rem",
                        width: "14.8rem",
                        borderColor: "#79747E",
                    }}
                    onClick={onClose}
                    disabled={loading}
                >
                    Fechar
                </Button>
            </Grid>
        </ModalComponent>
    );
};

export const ModalVideoIphone = ({
    onClose,
    open,
}: Props) => {
    const [loading, setLoading] = useState(false)
    const videoRef = useRef<HTMLVideoElement | null>(null);

    const handlePlay = () => {
        const video = videoRef.current;

        if (video) {
            if (video.requestFullscreen) {
                video.requestFullscreen();
            } else if ((video as any).webkitEnterFullscreen) {
                (video as any).webkitEnterFullscreen();
            } else if ((video as any).msRequestFullscreen) {
                (video as any).msRequestFullscreen();
            }
        }
    };

    return (
        <ModalComponent open={open} withoutHeader onClose={onClose}>
            <Grid
                width={"100%"}
                display={"flex"}
                flexDirection={"column"}
                gap={"1rem"}
            >
                <Typography fontSize={"1.8rem"} textAlign={"center"}>
                    Para continuar, <strong>baixe o atalho GYROO</strong>, logo em seguida clique no atalho para <strong>solicitar o crédito</strong>.
                </Typography>

                <Typography fontSize={"1.6rem"} textAlign={"center"} fontWeight={500} mb={"-1rem"} mt={"1rem"} sx={{ opacity: .5, fontStyle: "italic" }}>
                    Assista o vídeo abaixo e aprenda a baixar o atalho Gyroo
                </Typography>
            </Grid>

            <Grid
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                mt={"2.5rem"}
            >
                <video ref={videoRef} controls controlsList="nodownload" preload="auto" poster={Thumb} onPlay={handlePlay} style={{
                    maxWidth: '100%',
                    borderRadius: "20px"
                }}>
                    <source src={"https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/SMARTPHONE+ATALHO+.mp4"} type="video/mp4" />
                </video>

            </Grid>

            <Grid
                width={"100%"}
                display={"flex"}
                flexWrap={"wrap-reverse"}
                justifyContent={"flex-end"}
                flexDirection={"row"}
                gap={"1rem"}
                mt={"2.5rem"}
            >
                <Button
                    variant="outlined"
                    sx={{
                        height: "4rem",
                        width: "14.8rem",
                        borderColor: "#79747E",
                    }}
                    onClick={onClose}
                    disabled={loading}
                >
                    Fechar
                </Button>
            </Grid>
        </ModalComponent>
    );
};

export const ModalVideoPartner = ({
    onClose,
    open,
}: Props) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);

    const handlePlay = () => {
        const video = videoRef.current;

        if (video) {
            if (video.requestFullscreen) {
                video.requestFullscreen();
            } else if ((video as any).webkitEnterFullscreen) {
                (video as any).webkitEnterFullscreen();
            } else if ((video as any).msRequestFullscreen) {
                (video as any).msRequestFullscreen();
            }
        }
    };

    return (
        <ModalComponent open={open} onClose={onClose}>
            <Grid
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <video ref={videoRef} controls controlsList="nodownload" preload="metadata" poster={ThumbPartner} onPlay={handlePlay} playsInline style={{
                    maxWidth: '100%',
                    borderRadius: "20px"
                }}>
                    <source src={"https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/passo+a+passo+parceiro.mp4"} type="video/mp4" />
                </video>

            </Grid>
        </ModalComponent>
    );
};
